/**
 * Route for `role-types-default-advertiser-manager-affiliate-ma`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { RoleTypesDefaultAdvertiserManagerAffiliateMaPage } from "../features/role-types-default-advertiser-manager-affiliate-ma/RoleTypesDefaultAdvertiserManagerAffiliateMaPage";

export const roleTypesDefaultAdvertiserManagerAffiliateMaRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/role-types-default-advertiser-manager-affiliate-ma",
	component: RoleTypesDefaultAdvertiserManagerAffiliateMaPage,
});

export default roleTypesDefaultAdvertiserManagerAffiliateMaRoute;
